export namespace Permissions {
  //Create
  export enum Create {}

  //Access
  export enum Access {
    adminoverview = "opendash:can-access-admin-overview",
  }

  //Update
  export enum Update {}

  //Delete
  export enum Delete {}
}
